module.exports = __webpack_public_path__ + "img/status_preparing_ingredients_1.fd44772f.png";